import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import cx from 'classnames'
import {
    playHoverSound,
    playButtonClickSound,
    playTabClickSound,
    playOneReserveProduceSuccessSound,
} from 'state/actions/sounds'
import submitUserFlag from 'state/actions/user_flags'

import styles from './ReserveSelect.scss'
import { KEY_CODES, MEDIA_QUERIES, USER_FLAGS } from 'constants'
import ReserveSelectItem from './components/ReserveSelectItem/ReserveSelectItem'
import { changeSelectedLevel } from 'state/actions/reserve_level_select'
import {
    getReservesQueueByLevel,
    getSortedProductionReserves,
    groupReservesByLevel,
    isReserveVisible,
} from 'helpers/reserves'
import { ScrollArea } from 'react-wot-bootstrap'
import { ALL_RESERVE_QUEUES_END, TUTORIAL_TEXT } from './constants'
import { getEndDateMessage } from 'helpers/datetime'
import moment from 'moment'
import { TutorialArrow } from 'components/TutorialArrow/TutorialArrow'

class ReserveSelect extends React.Component {
    static propTypes = {
        building: PropTypes.object.isRequired,
        buildingUpgrade: PropTypes.shape({
            highlighted: PropTypes.bool.isRequired,
        }).isRequired,
        reserveInfo: PropTypes.object.isRequired,
        reserves: PropTypes.arrayOf(PropTypes.object).isRequired,
        selectedLevel: PropTypes.number.isRequired,
        tutorialVisible: PropTypes.bool.isRequired,
        changeSelectedLevel: PropTypes.func.isRequired,
        submitUserFlag: PropTypes.func.isRequired,
        playOneReserveProduceSuccessSound: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
        playButtonClickSound: PropTypes.func.isRequired,
        playTabClickSound: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        this.state = {
            opened: false,
            reservesQueueByLevel: {},
            mediumScreen: window.matchMedia(MEDIA_QUERIES.MEDIUM).matches,
        }
        this.onKeyUp = this.onKeyUp.bind(this)
        this.handleClickaway = this.handleClickaway.bind(this)
    }

    update(reserves = this.props.reserves) {
        clearTimeout(this.timeoutId)

        this.setState({
            reservesQueueByLevel: getReservesQueueByLevel(reserves),
        })

        const reserve = getSortedProductionReserves(reserves)
            .find((reserve) => reserve.productionEnds > Date.now())

        if (reserve) {
            this.timeoutId = setTimeout(() => {
                this.update()
            }, reserve.productionEnds - Date.now())
        }
    }

    onKeyUp(e) {
        if (e.keyCode === KEY_CODES.ESCAPE && this.state.opened) {
            e.stopImmediatePropagation()
            this.setState({ opened: false })
        }
    }

    handleClickaway(e) {
        if (this.refs.popup && !this.refs.popup.contains(e.target) && !this.refs.bar.contains(e.target)) {
            this.setState({ opened: false })
        }
    }

    handleMediaQueryChange = (event) => {
        const mediumScreen = event.matches

        if (this.state.mediumScreen !== mediumScreen) {
            this.setState({ mediumScreen })
        }
    }

    componentWillMount() {
        this.update()
        window.addEventListener('keydown', this.onKeyUp, true)
        window.addEventListener('mousedown', this.handleClickaway)
        window.matchMedia(MEDIA_QUERIES.MEDIUM).addEventListener('change', this.handleMediaQueryChange)
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyUp, true)
        window.removeEventListener('mousedown', this.handleClickaway)
        window.matchMedia(MEDIA_QUERIES.MEDIUM).removeEventListener('change', this.handleMediaQueryChange)
        clearTimeout(this.timeoutId)
    }

    componentWillReceiveProps({ reserves }) {
        this.update(reserves)
    }

    render() {
        const { building, buildingUpgrade, reserveInfo, reserves, selectedLevel } = this.props
        const { opened, reservesQueueByLevel } = this.state
        const advanced = building.level > 1

        const className = cx(styles.bar, {
            [styles.bar__advanced]: advanced,
            [styles.bar__opened]: opened,
            [styles.bar__queue]: advanced && Boolean(reservesQueueByLevel[selectedLevel]),
        })

        const allReservesByLevel = groupReservesByLevel(reserves.filter(isReserveVisible))
        const reservesByLevel = {}
        for (let level = 1; level < building.level + 1; level++) {
            reservesByLevel[level] = allReservesByLevel[level] || []
        }
        const orderedLevels = Object.keys(reservesByLevel)
            .map(level => parseInt(level))
            .sort((a, b) => b - a)

        const sortedProductionReserves = getSortedProductionReserves(reserves)
        const lastReserve = sortedProductionReserves[sortedProductionReserves.length - 1]

        return (
            <React.Fragment>
                {lastReserve && (
                    <div className={styles.reserveQueueEnd}>
                        {ALL_RESERVE_QUEUES_END(
                            <span className={styles.highlight}>
                            {getEndDateMessage(moment(lastReserve.productionEnds))}
                        </span>
                        )}
                    </div>
                )}
                <div className={styles.base}>
                    <div
                        ref="bar"
                        className={className}
                        onMouseEnter={() => {
                            advanced && this.props.playHoverSound()
                        }}
                        onClick={() => {
                            if (advanced) {
                                this.props.playButtonClickSound()
                                this.setState({ opened: !opened })
                            }

                            if (this.props.tutorialVisible) {
                                this.props.submitUserFlag(USER_FLAGS.LOW_LEVEL_RESERVES_VISITED)
                            }
                        }}
                    >
                        <ReserveSelectItem
                            level={buildingUpgrade.highlighted ? building.level : selectedLevel}
                            reserveInfo={reserveInfo}
                            reserves={reserves}
                            highlighted={buildingUpgrade.highlighted}
                            playSound={this.props.playOneReserveProduceSuccessSound}
                            reservesQueueInfo={advanced ? reservesQueueByLevel[selectedLevel] : undefined}
                        >
                            <div className={styles.holder}/>
                            <div
                                className={cx(
                                    styles.tutorialWrapper,
                                    this.props.tutorialVisible && styles.tutorialWrapper__active
                                )}
                            >
                                <div className={styles.arrow}/>
                                <TutorialArrow
                                    isHidden={!this.props.tutorialVisible}
                                    showBorder={false}
                                    arrowPosition="top"
                                    text={TUTORIAL_TEXT}
                                />
                            </div>
                        </ReserveSelectItem>
                    </div>
                    {opened && (
                        <div ref="popup" className={styles.popup}>
                            <ScrollArea
                                scrollableAreaHeight={this.state.mediumScreen ? 360 : 280}
                                modifier="toolbar"
                            >
                                {orderedLevels.map(level => (
                                    <div
                                        key={`reserves_of_${level}_level`}
                                        className={cx(
                                            styles.row,
                                            reservesQueueByLevel[level] && styles.row__queue
                                        )}
                                        onMouseEnter={() => {
                                            this.props.playHoverSound()
                                        }}
                                        onClick={() => {
                                            this.props.playTabClickSound()
                                            this.props.changeSelectedLevel(level)
                                            this.setState({ opened: false })
                                        }}
                                    >
                                        <ReserveSelectItem
                                            level={level}
                                            reserveInfo={reserveInfo}
                                            reserves={reservesByLevel[level]}
                                            highlighted={false}
                                            reservesQueueInfo={reservesQueueByLevel[level]}
                                        >
                                            <div className={styles.holder}/>
                                        </ReserveSelectItem>
                                    </div>
                                ))}
                            </ScrollArea>
                        </div>
                    )}
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = (state, { buildingId }) => {
    const {
        buildings,
        buildingUpgrade,
        clanReserves,
        reserveLevelSelect,
        settings,
    } = state

    const building = buildings[buildingId]
    const reserveType = settings.buildings[building.type].reserve_type

    return {
        building,
        buildingUpgrade,
        reserveInfo: settings.reserves[reserveType],
        reserves: clanReserves[reserveType],
        selectedLevel: reserveLevelSelect.selectedLevel,
        tutorialVisible: !state.userFlags[USER_FLAGS.LOW_LEVEL_RESERVES_VISITED] && building.level > 1,
    }
}

export const mapDispatchToProps = {
    changeSelectedLevel,
    submitUserFlag,
    playOneReserveProduceSuccessSound,
    playHoverSound,
    playButtonClickSound,
    playTabClickSound,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReserveSelect)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveSelect/ReserveSelect.jsx